import styled from "styled-components";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div`
    padding: 0;
`;

export const Inner = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[2]}px 0 ${theme.space[1]}px;
    cursor: pointer;
    ${IconWrapper} {
        color: ${theme.colors.white};
    }
`;

export const Body = styled.div`
    padding: ${theme.space[3]}px 0;
`;
